<template>
  <div class="col-md-4 col-sm-6 col-lg-3 col-xl-2 mb-2">
    <div class=" p-1 product-content  border rounded">
      <div class="item-img text-center mb-25 hover-download">
        <a :href="'https://drop.brushme.com.ua/download/?article='+product.article"
           class="down-icon-btn" target="_blank">
          {{ lexicon.drop_wd_photo }}
          <i class="feather icon-download"></i>
        </a>
        <span class="badge badge-info position-absolute"
              v-if="product.size">{{ product.size }}{{ lexicon.drop_product_cm }}</span>
        <span class="badge badge-light-primary position-absolute position-right-0"
              v-if="product.rt">{{ product.rt }}</span>
        <span class="badge badge-danger position-absolute position-right-0"
              v-if="product.sale">SALE</span>
        <img class="w-100 rounded" :src="product.image"
             :title="product.article">
      </div>
      <div class="item-name ">
        <div class="text-primary text-center">
          <span v-if="product.preorder">{{ lexicon.drop_preorder }}</span>
          <span v-else><br></span>
        </div>
        <h5 class="d-flex justify-content-between my-25">
          <span><i class="feather icon-image ml-25" v-if="product.custom"></i> {{ product.article }}</span>
          <span>{{ product.price }}{{ lexicon[user.currency] }}</span>
        </h5>
        <span class="oneline">{{ product.name }}</span>
      </div>
      <div>
        <button class="btn btn-primary btn-block"
                :disabled="!product.stock"
                @click="$emit('addProductToCart',product)">
          <i class="feather icon-shopping-cart mr-25"></i>
          {{ lexicon.drop_to_cart }}

        </button>
      </div>
    </div>
  </div>

</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
  props: ['product'],
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
    ...mapState({
      lexicon: 'lexicon',
    })
  },
  methods: {
    ...mapActions({
      LogoutAction: 'auth/Logout'
    }),
    Logout() {
      this.LogoutAction().then(() => {
        this.$router.replace({
          name: 'login'
        })
      })
    }
  }
}
</script>
